import * as React from "react"

import { AppAntSwitch } from "@components"
import { productsInStock } from "@signals"


export default function DIPProductInStockSwitch({ ...props }) {
    return <AppAntSwitch
        checked={ productsInStock.value }
        onChange={ (e) => { productsInStock.value = e.target.checked } }
        trueText='Only Stock'
        falseText='All'
        {...props}
    />
}